module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1n",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "",
      "src": "image/telephone_isolated.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("These stories are the product of a fascination with microfiction, a love of eccentric tales, and a New Year’s resolution to write one 55-word story a day (which lasted till May 5; I have a thing for tidy endings).")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("I suggest two or three stories as part of your recommended daily literary intake.")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("Happy reading!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1n t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "alt": "",
      "src": "image/stool-isolated.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "TOC t"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub#_idTextAnchor004"
    }
  }, [_vm._v("The Best-Laid Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub#_idTextAnchor005"
    }
  }, [_vm._v("He Loves Me, He Loves Me Not (Part I)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub#_idTextAnchor006"
    }
  }, [_vm._v("Growing Pains")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub#_idTextAnchor007"
    }
  }, [_vm._v("Lucky Duck")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub#_idTextAnchor008"
    }
  }, [_vm._v("Artistic Appreciation")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor009"
    }
  }, [_vm._v("Backseat Driver")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor010"
    }
  }, [_vm._v("Complementary")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor011"
    }
  }, [_vm._v("Frankenstein Revisited")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor012"
    }
  }, [_vm._v("Art Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor013"
    }
  }, [_vm._v("Lip Service")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor014"
    }
  }, [_vm._v("A Literary Death")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor015"
    }
  }, [_vm._v("Fashion Victim")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor016"
    }
  }, [_vm._v("Have Your Cake and Eat It Too ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor017"
    }
  }, [_vm._v("Some People Eat to Live . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub1#_idTextAnchor018"
    }
  }, [_vm._v("At Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor019"
    }
  }, [_vm._v("Blurring the Lines")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor020"
    }
  }, [_vm._v("Fatal Beauty")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor021"
    }
  }, [_vm._v("Deadly Detox")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor022"
    }
  }, [_vm._v("20/20ish")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor023"
    }
  }, [_vm._v("Seafarer")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor024"
    }
  }, [_vm._v("Ajar")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor025"
    }
  }, [_vm._v("Bun in the Oven")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor026"
    }
  }, [_vm._v("A Part of This Place")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor027"
    }
  }, [_vm._v("Enemy Territory")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub2#_idTextAnchor028"
    }
  }, [_vm._v("Food for Thought")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor029"
    }
  }, [_vm._v("He Loves Me, He Loves Me Not (Part II)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor030"
    }
  }, [_vm._v("Dinner Forks")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor031"
    }
  }, [_vm._v("Lovesick")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor032"
    }
  }, [_vm._v("Last Request")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor033"
    }
  }, [_vm._v("Sink or Swim")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor034"
    }
  }, [_vm._v("Hansel and Gretel 2019")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor035"
    }
  }, [_vm._v("Mis-conception")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor036"
    }
  }, [_vm._v("Farmers"), _c('span', [_vm._v("’")]), _vm._v(" Market")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor037"
    }
  }, [_vm._v("Miscalculation")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub3#_idTextAnchor038"
    }
  }, [_vm._v("Testing the Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor039"
    }
  }, [_vm._v("Pet Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor040"
    }
  }, [_vm._v("The End (Part I)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor041"
    }
  }, [_vm._v("It Only Takes a Minute")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor042"
    }
  }, [_vm._v("The Nose Knows")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor043"
    }
  }, [_vm._v("Symbiosis")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor044"
    }
  }, [_vm._v("You Are Always on My Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor045"
    }
  }, [_vm._v("Weighed Down")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor046"
    }
  }, [_vm._v("Shell-shocked")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor047"
    }
  }, [_vm._v("Sibling Rivalry")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub4#_idTextAnchor048"
    }
  }, [_vm._v("Sound of Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor049"
    }
  }, [_vm._v("Till Death")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor050"
    }
  }, [_vm._v("X Marks the Spot")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor051"
    }
  }, [_vm._v("Glass Half-Empty")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor052"
    }
  }, [_vm._v("Unrequited")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor053"
    }
  }, [_vm._v("Osmosis")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor054"
    }
  }, [_vm._v("Chart-Toppers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor055"
    }
  }, [_vm._v("Destined to Be Apart")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor056"
    }
  }, [_vm._v("Bite Me ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor057"
    }
  }, [_vm._v("Domestic Bliss")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/55SSS_epub5#_idTextAnchor058"
    }
  }, [_vm._v("The End (Part II)")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1n"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Blurring_the_Lines_-_modified_2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("The Stories")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1n"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Best_Laid_Plans.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Stories-titles"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("The Best-Laid Plans")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("He was sweet, quirky, and smitten. She could tell him anything. They laughed at the same idiotic things and planned wildly unfeasible trips. ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("He was like family, that’s all. He was her backup, her Plan B.")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("She eyed the wedding invite warily. It hadn’t occurred to her that he might be someone else’s Plan A.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/He_Loves_Me-He_Lovs_Me_Not__1_.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Stories-titles"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("He Loves Me, He Loves Me Not (Part I)")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("He remembers her when it snows. That’s how they met forty years ago, two clueless souls searching for a donut fix in a blizzard. ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("They live in California now, and he keeps looking at her with vacant eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("She thumbs through the Alaska brochures, contemplating a future where he smiles when  she enters a room. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Growing_Pains.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Stories-titles"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Growing Pains")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("The spring before turning thirteen, they discovered a hole in the wall between their two schools, big enough for a petite preteen or her gangly crush to squeeze through.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("Puberty had other plans, though. Over the summer, her chest filled out and his shoulders broadened, making the scramble through impossible.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("They simply outgrew each other.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Lucky_Duck.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "Stories-titles"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Lucky Duck")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("The day their love died, so did an unsuspecting duck. ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("Done with weeping on a park bench, she flung her engagement ring into the lake. It had been handed down through generations, only to get lodged in the greedy bird’s gullet. ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("He would want the ring back. She hoped he wouldn’t mind the unconventional wrapping.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Artistic_Appreciation.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "Stories-titles"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Artistic Appreciation")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("He was painfully beautiful up close. She wanted to drink in his lines as though he were one of her favorite roped-off paintings. ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("There was a bare wall in her new apartment that needed adornment. ")]), _vm._v(" "), _c('p', {
    staticClass: "Stories-body-text"
  }, [_vm._v("She invited him for drinks, admiring the way the rust-colored paint brought out the flecks of gold in his eyes.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8096b40e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/55SSS_epub.vue
// module id = 57
// module chunks = 0